import { render } from "./glassitem-colorselect.vue?vue&type=template&id=1a81f715"
import script from "./glassitem-colorselect.vue?vue&type=script&lang=js"
export * from "./glassitem-colorselect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__